export const NOTIFICATION_BANNER_FORM_IDENTIFIER =
  'app/AppSettings/NOTIFICATION_BANNER_FORM_IDENTIFIER';
export const HOMEPAGE_BANNER_FORM_IDENTIFIER = 'app/AppSettings/HOMEPAGE_BANNER_FORM_IDENTIFIER';
export const SPLASH_IMAGE_FORM_IDENTIFIER = 'app/AppSettings/SPLASH_IMAGE_FORM_IDENTIFIER';
export const DISCLAIMERS_FORM_IDENTIFIER = 'app/AppSettings/DISCLAIMERS_FORM_IDENTIFIER';

export const INIT = 'app/AppSettingsPage/INIT';
export const INIT_FAILED = 'app/AppSettingsPage/INIT_FAILED';

export const SAVE_NOTIFICATION_BANNER = 'app/AppSettingsPage/SAVE_NOTIFICATION_BANNER';
export const SAVE_FORM = 'app/AppSettingsPage/SAVE_FORM';

export const SAVE_DISCLAIMERS = 'app/AppSettingsPage/SAVE_DISCLAIMERS';
